import { LOCAL_STORAGE_KEY } from "@/constants/localStorageKey";
import { VIP_CERT_PAGE } from "@/utils/host";
import { Button, Checkbox } from "antd";
import { useMemo } from "react";
import HBModal, { ModalProps } from "../HBModal";
import ModalWrap from "../HBModal/ModalWrap";
import styles from "./index.module.less";

interface MutiSubjectTipProps extends Omit<ModalProps, "children"> {
  subjects?: CERTSubject[];
}

/**
 * 多主体未填写提示
 * @returns
 */
export function MutiSubjectTip({ subjects, ...props }: MutiSubjectTipProps) {
  const noInfoCount = useMemo(() => {
    return subjects.filter((item) => !item.subject_info?.name).length;
  }, [subjects]);

  return (
    <HBModal
      className={styles.mutiSubjectTip}
      title="授权主体填写"
      width={480}
      footer={null}
      maskClosable={false}
      {...props}
      bodyStyle={{ padding: "12px 24px 24px 24px" }}
    >
      <div style={{ fontSize: 16, fontWeight: 600 }}>
        您当前有多个授权主体，请完善授权主体信息。
      </div>
      <div className="color-text-2">
        当前授权主体共 {subjects.length} 个（
        {noInfoCount}个待填写
        <a
          className="primary-text-btn"
          href={VIP_CERT_PAGE}
          onClick={props.onCancel}
          target="_blank"
        >
          去填写
        </a>
        ）
      </div>
      <div className={styles.footer}>
        <Checkbox
          className={styles.checkBox}
          onChange={(e) => {
            e.target.checked
              ? localStorage.setItem(LOCAL_STORAGE_KEY.HB_MUTI_SUBJECT_TIP, "1")
              : localStorage.removeItem(LOCAL_STORAGE_KEY.HB_MUTI_SUBJECT_TIP);
          }}
        >
          不再提醒
        </Checkbox>

        <Button type="primary" onClick={props.onOk}>
          我知道了
        </Button>
      </div>
    </HBModal>
  );
}

export const MutiSubjectTipModal = ModalWrap(MutiSubjectTip);
